import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { ButtonListButtonItem } from '../../interfaces/storyblok-buttons';
import { StoryblokCdnPipe } from '../../pipes/storyblok-cdn.pipe';
import { StoryblokLinkUrlPipe } from '../../storyblok-link-url.pipe';

@Component({
  selector: 'app-storyblok-button-item',
  templateUrl: './storyblok-button-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective, SvgComponent, StoryblokLinkUrlPipe, StoryblokCdnPipe],
})
export class StoryblokButtonItemComponent {
  @Input({ required: true }) button: ButtonListButtonItem;
  @Output() onClick = new EventEmitter();
}
